import { combineReducers } from 'redux';
import { FETCH_ZONE, FETCH_ZONE_SUCCESS } from '../actions/zone';

const item = (state = null, action) => {
  switch (action.type) {
    case FETCH_ZONE_SUCCESS:
      return action.zone;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_ZONE:
      return true;
    case FETCH_ZONE_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  item,
  isFetching,
});

export const getIsFetching = state => state.plan.zone.isFetching;

export const getZone = state => state.plan.zone.item;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/reducers/zone.js